import { Box } from "@mui/material";
import React from "react";
import { useRecoilState } from "recoil";
import { authState } from "src/store/auth";
import FirstBranchPopup from "./first-branch-popup";

const NoAccessPage: React.FC = () => {
  const [auth] = useRecoilState(authState);
  const { user, permissions } = auth;

  const newAccount = permissions.length === 0 && user?.type === "owner";

  return (
    <Box
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      minHeight={"400px"}
    >
      <FirstBranchPopup open={newAccount} companyId={user?.company?.id} />
    </Box>
  );
};

export default NoAccessPage;
